import 'bootstrap/scss/bootstrap.scss'
import './src/styles/global-version.scss'

export { wrapRootElement } from './gatsby-shared'

export const onClientEntry = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return
  }

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister()
    })
  })
}
